<template>
    <a-card class="UserDetail">
        <div class="info">
            <div class="i_item">
                <p>ID:{{accountId}}</p>
                <div class="center">
                    <img :src="userInfo.accountInfo.profilePicture | filterUrl" v-if="userInfo.accountInfo.profilePicture">
                    <img src="@/assets/img/avator.jpg" v-else>
                    <h4>{{userInfo.accountInfo.nickname}}</h4>
                </div>
                <p>{{userInfo.accountInfo.mobile}}</p>
                <p>{{userInfo.accountInfo.createTime}}</p>
            </div>
            <div class="i_item">
                <p class="tit">学生信息</p>
                <div class="left" v-if="userInfo.userInfos.length">
                    <img :src="userInfo.userInfos[0].faceUrl" v-if="userInfo.userInfos[0].faceUrl | filterUrl">
                    <img src="@/assets/img/avator.jpg" v-else>
                    <div>
                        <p>
                            {{userInfo.userInfos[0].realName}}
                            <a-icon type="man" v-if="userInfo.userInfos[0].gender == 1" style="color:#00A8F1;margin-left:10px;margin-top:5px;"/>
                            <a-icon type="woman" v-else style="color:#eb2f96;margin-left:10px;margin-top:5px;"/>
                        </p>
                        <p>
                            <a-icon type="contacts" style="margin-right:10px;margin-top:5px;"/>
                            {{userInfo.userInfos[0].birthday}}
                        </p>
                    </div>
                </div>
                <div class="left" v-else style="justify-content: center;font-size:16px;color:#cccccc;">
                    暂无数据
                </div>
            </div>
            <div class="i_item">
                <p class="tit">标签</p>
                <div class="tags">
                    <span v-for="(item,index) in tags" :key="item">
                        {{item}}
                        <i @click="removeTag(index)">X</i>
                    </span>
                    <span class="add" @click="addtag()">+</span>
                </div>
            </div>
            <div class="i_item" style="border:none;">
                <p class="tit">备注</p>
                <a-textarea
                    :maxLength="200"
                    @blur="pressRemark"
                    style="margin-bottom:15px;"
                    v-model="userInfo.accountInfo.remark"
                    placeholder="输入备注，限制200字"
                    :auto-size="{ minRows: 3}"/>
            </div>
            <div class="rightsx"></div>
        </div>
        <div class="tables">
            <div class="table">
                <div class="title">
                    <span></span>
                    <h6>统计信息</h6>
                </div>
                <a-table style="min-width: 800px;"
                    :columns="totalColumns"
                    row-key="price"
                    :pagination="false"
                    :dataSource="totalData">
                    <div slot="price" slot-scope="text, record">
                        ￥{{text.price}}
                    </div>
                </a-table>
            </div>
            <div class="table">
                <div class="title">
                    <span></span>
                    <h6>课程内容</h6>
                </div>
                <a-table style="min-width: 800px;"
                    :columns="courseColumns"
                    row-key="itemId"
                    :pagination="tableRelevant.tablePagination"
                    :loading="tableRelevant.tableLoading"
                    :locale="tableRelevant.locale"
                    :dataSource="tableRelevant.tableDataSource">
                    <div slot="outOrderId" slot-scope="text, record">
                        <a @click="goOrder(text)" style="text-decoration: underline;">{{text.outOrderId}}</a>
                    </div>
                    <div slot="progress" slot-scope="text, record">
                        <span>{{ text.progress == 0 ? '未开始' : text.progress == 100 ? '已完成' : '进行中'}}</span>
                    </div>
                </a-table>
            </div>
        </div>
        <a-modal
            title="标签"
            :visible="tagForm.visible"
            destroyOnClose
            :maskClosable="true"
            :confirm-loading="tagForm.loading"
            @ok="handleOk"
            @cancel="handleCancel">
                <a-form-model
                    ref="ruleForm"
                    :model="tagForm.data"
                    :rules="tagForm.rules"
                    :label-col="{span:6}"
                    :wrapper-col="{span:14}">
                    <a-form-model-item ref="tagName" label="标签名称" prop="tagName">
                        <a-input v-model="tagForm.data.tagName"/>
                    </a-form-model-item>
                </a-form-model>
        </a-modal>
    </a-card>
</template>

<script>
import $Bus from "@/pages/projectImpl/js/eventBus"
import {tableRelevant} from "@/pages/projectImpl/js/utils";

const totalColumns = [
    { title: '订单总量', key: "1", dataIndex: 'orderNum',},
    { title: '消费金额', key: "2", scopedSlots: {customRender: 'price'}},
    { title: '上次购买时间', key: "3", dataIndex: 'lastOpenCourseTime'},
]
const courseColumns = [
    { title: '名称', key: "4", dataIndex: 'name',},
    { title: '来源订单', key: "5", scopedSlots: {customRender: 'outOrderId'}},
    { title: '加入时间', key: "6", dataIndex: 'createTime'},
    { title: '状态', key: "7", scopedSlots: {customRender: 'progress'}},
]
export default {
    name:'UserDetail',
    data () {
        return {
            tags:[],
            totalColumns,
            totalData:[],
            courseColumns,
            tableRelevant: tableRelevant.call(this,this.GetUserCoursePageList),
            tagForm:{
                visible:false,
                loading:false,
                data:{
                    tagName:''
                },
                rules:{
                    tagName: [{ required: true, message: "请填写标签名称", trigger: "blur" }]
                },
            },
            accountId:'',
            userInfo:{
                accountInfo:{},
                userInfos:[]
            },
        }
    },
    created () {

    },
    mounted(){
        this.accountId = this.$route.query.accountId
        this.getInfo()
        this.setTitle()
        this.GetUserOrderSummary()
        this.GetUserCoursePageList(1)
    },
    methods: {
        setTitle(){
            const arr = ["首页","运营中心",{name: "用户管理",path: "/operate/UserManage"},"用户详情"];
            $Bus.$emit("pageHeaderBreadcrumb", arr);
        },
        getInfo(){
            let params = {
                accountId:this.accountId
            }
            this.$http.operate.GetUserByAccountId(params)
            .then(res => {
                    this.userInfo = res.data.data
                    this.userInfo.userInfos[0].birthday = this.userInfo.userInfos[0].birthday.split(' ')[0]
                    if(this.userInfo.accountInfo.tags != "[]")
                    this.tags = this.userInfo.accountInfo.tagList
               
            })
            .catch(err=>{

            })
            
        },
        goOrder(text){
            this.$router.push({
                path:'/operate/GoodsManage/OrderDetail',
                query:{
                    outOrderId:text.outOrderId,
                    orderId:text.orderId,
                    mobile:text.orderMobile,
                }
            })
        },
        addtag(){
            this.tagForm.visible = true
        },
        removeTag(index){
            this.tags.splice(index,1)
            this.editTag()
        },
        pressRemark(){
            this.editTag()
        },
        handleOk(){
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.editTag()
                } else {
                }
            });
        },
        editTag(){
            let arr = JSON.parse(JSON.stringify(this.tags))
            if(arr.includes(this.tagForm.data.tagName)){
                this.$message.destroy();
                this.$message.error('标签已存在，请重新输入')
                return
            }
            if(this.tagForm.data.tagName){
                arr.push(this.tagForm.data.tagName)
            }
            let params = {
                id:this.accountId,
                tags:arr,
                remark:this.userInfo.accountInfo.remark
            }
            this.tagForm.loading = true
            this.$http.operate.EditAccount(params)
            .then(res => {
                this.tagForm.loading = false
                this.$message.destroy();
                    this.$message.success(res.data.data)
                    this.getInfo()
                    this.tagForm.visible = false
                    this.$refs.ruleForm.resetFields();
               
            })
            .catch(err=>{
                this.tagForm.loading = false
            })
        },
        // 统计信息
        GetUserOrderSummary(){
            let params = {
                accountId:this.accountId
            }
            this.$http.operate.GetUserOrderSummary(params)
            .then(res => {
                    if(res.data.data){
                        this.totalData.push(res.data.data)
                    }
              
            })
            .catch(err=>{

            })
        },
        // 课程内容
        GetUserCoursePageList(pageIndex){
            let params = {
                accountId:this.accountId,
                pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
                pageSize: this.tableRelevant.tablePagination.pageSize,
            }
            this.tableRelevant.tableLoading = true
            this.$http.operate.GetUserCoursePageList(params)
            .then(res => {
                this.tableRelevant.tableLoading = false
                    this.tableRelevant.tableDataSource = res.data.data.items
                    this.tableRelevant.tablePagination.total = res.data.data.totalCount;
                    this.tableRelevant.tablePagination.current = res.data.data.pageIndex;
               
            })
            .catch(err=>{
                this.tableRelevant.tableLoading = false
            })
        },
        handleCancel(){
            this.tagForm.visible = false
            this.$refs.ruleForm.resetFields();
        },
    }
}
</script>

<style scoped lang="less">
.UserDetail{
    width:100%;
    height:100%;
    /deep/ .ant-card-body{
        display:flex;
        height:100%;
        justify-content: space-between;
        .info{
            width:30%;
            position: relative;
            .i_item{
                width:100%;
                border-bottom: 1px dashed #ccc;
                margin-bottom:15px;
                p{
                    font-size:14px;
                }
                .tit{
                    font-weight:600;
                }
                .center{
                    text-align:center;
                    img{
                        width:100px;
                        height:100px;
                        object-fit: contain;
                        background:#ccc;
                    }
                    h4{
                        margin-top:10px;
                        font-weight:600;
                    }
                }
                .left{
                    display:flex;
                    margin-bottom: 30px;
                    p{
                        margin:0;
                    }
                    img{
                        width:80px;
                        height:80px;
                        object-fit: contain;
                        background:#ccc;
                    }
                    div{
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;
                        margin-left:15px;
                    }
                }
                .tags{
                    display:flex;
                    flex-wrap: wrap;
                    margin-bottom: 15px;
                    span{
                        display:inline-block;
                        padding:0 5px;
                        background:#f9f9f9;
                        border:1px solid #ccc;
                        font-size:14px;
                        border-radius: 5px;
                        margin-right:10px;
                        margin-bottom: 15px;
                        cursor: pointer;
                        i{
                            font-style:normal;
                            margin-left: 10px;
                            display:none;
                            color: #f00;
                        }
                    }
                    .add{
                        padding:0 10px;
                        cursor: pointer;
                        border: 1px dashed #ccc;
                    }
                    span:hover i{
                        display:inline-block;
                    }
                }
            }
            .rightsx{
                width:1px;
                height:80%;
                background:#ccc;
                position: absolute;
                right: -50px;
                top: 45px;
            }
        }
        .tables{
            width:65%;
            padding: 0 10px;
            .table{
                width:100%;
                margin-bottom:20px;
                .title{
                    width: 100%;
                    position: relative;
                    padding:0 10px;
                    margin-bottom:10px;
                    span{
                        display: block;
                        width: 5px;
                        height: 20px;
                        background:#00A8F1;
                        position: absolute;
                        left: 0;
                        top: 2px;
                    }
                    h6{
                        font-size: 16px;
                        font-weight: 600;
                    }
                }
            }
        }
    }
    /deep/ .ant-card-body::before{
        display:none;
    }
    /deep/ .ant-card-body::after{
        display:none;
    }
    /deep/ .ant-pagination{
        margin-top:100px;
    }
}
</style>
